<div class="kt-form kt-form--label-right  mb-2">
  <div class="row align-items-center">
    <div class="col-xl-12 order-2 order-xl-1 pr-0">
      <form class="row align-items-center" [formGroup]="form">
        <div class="col-12 row mb-2 pr-0">
          <div class="col-md-1 kt-form__label col-form-label">
            <label>Code:</label>
          </div>
          <div class="col-md-2 kt-form__control">
            <input type="text" formControlName="code" placeholder="Search" class="form-control">
          </div>
          <div class="col-md-1 kt-form__label col-form-label">
            <label>Name:</label>
          </div>
          <div class="col-md-2 kt-form__control">
            <input type="text" formControlName="name" placeholder="Search" class="form-control">
          </div>
          <div class="col-md-1 kt-form__label col-form-label">
            <label>Region:</label>
          </div>
          <div class="col-md-2 kt-form__control">
            <select class="form-control" formControlName="region">
              <option value="all"> All </option>
              <option [value]="item.country_code" *ngFor="let item of regions">{{ item.country_code }}</option>
            </select>
          </div>
          <div class="col-md-1 kt-form__label col-form-label">
            <label>Status:</label>
          </div>
          <div class="col-md-2 kt-form__control">
            <select class="form-control" formControlName="status">
              <option value="all"> All </option>
              <option [value]="i" *ngFor="let value of dropdown.status; let i = index">{{ value }}</option>
            </select>
          </div>
        </div>
        <div class="col-12 row mb-2 pr-0">
          <div *ngIf="isAdmin" class="col-md-1 kt-form__label col-form-label">
            <label>Type:</label>
          </div>
          <div *ngIf="isAdmin" class="col-md-2 kt-form__control">
            <select class="form-control" formControlName="type">
              <option value="all"> All </option>
              <option value="1">Internal</option>
              <option value="0">External</option>
            </select>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="kt-section col-12 row d-flex justify-content-between mb-3 mt-3">
  <div class="dropdown dropdown-inline">
    <kt-search-button [loading]="searchBtnLoading" [disabledButton]="loading" (search)="onSubmit()"></kt-search-button>
    <kt-clear-button [loading]="clearBtnLoading" [disabledButton]="loading" (clear)="onClear()"></kt-clear-button>
  </div>
</div>
<div class="kt-section">
  <div class="kt-section__content">
    <div class="table-responsive">
      <table class="table table-bordered table-hover table-striped table-sortable">
        <thead>
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Region</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody *ngIf="(credentials$ | async) as rows">
          <tr *ngFor="let row of rows">
            <td>{{ row.custom_code }}</td>
            <td>{{ row.name }}</td>
            <td>{{ row.region }}</td>
            <td>
              <span class="kt-badge status-color kt-badge--inline kt-badge--pill kt-badge--wide" [ngClass]="'kt-badge--' + row.status"> {{ status[row.status ]}} </span>
            </td>
            <td>
              <button *ngIf="canEditCredential" title="Edit" class="btn btn-outline-hover-info btn-elevate btn-sm btn-icon btn-icon-sm" (click)="onOpenDialog('edit', row)"><i class="fas fa-edit"></i></button>
            </td>
          </tr>
        </tbody>
        <tbody shared-table-handler [loading]="loading" [dataLength]="dataLength" class="text-gray-600 fw-bold"></tbody>
      </table>
    </div>
    <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
      <ngb-pagination [pageSize]="pageSize" [(page)]="page" [maxSize]="maxSize" [directionLinks]="true" [boundaryLinks]="true" [rotate]="true" [collectionSize]="pagination.total" (pageChange)="onViewPageBy(page)">
      </ngb-pagination>
      <div class="kt-pagination__toolbar">
        <select (change)="onPerPage($event)" [(ngModel)]="pageSize" class="form-control kt-font-brand page-size">
          <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
        </select>
        <span class="pagination__desc">
          Showing {{pagination.from}} to {{pagination.to}} of {{ pagination.total | number : '1.0' }} records
        </span>
      </div>
    </div>
  </div>
</div>
